import React from 'react';
import FarmingTrackerApp from '../components/FarmingTrackerApp';

/**
 * Main page for the Farming Tracker application
 * This is a simplified version that uses our componentized structure
 */
const FarmingTracker: React.FC = () => {
  return <FarmingTrackerApp />;
};

export default FarmingTracker;